import qualifications from 'utils/qualifications';
import { arrFieldsToKeys } from 'utils/functions';
import { DB_PREFIX_JOBS, DB_PREFIX_QUALIFICATIONS } from './constants';

export default {
  [DB_PREFIX_QUALIFICATIONS]: {
    ...arrFieldsToKeys(qualifications),
  },
  [DB_PREFIX_JOBS]: [],
};
